/*global DSV, jQuery */

/** 
 * DSV siteSelector
 */

(function ($, window) {
    "use strict";

    const accordionBreakpoint = DSV.tools.screenSizes.large;

    DSV.ui.siteSelector = {

        DOM: {
            module: $('.site-selector')
        },

        removeAccordionEvents: function() {
            const el = document.querySelector('.site-selector .page-content__container'),
                elClone = el.cloneNode(true);

            el.parentNode.replaceChild(elClone, el);
        },

        undoAccordion: function() {
            if(this.DOM.module.hasClass('accordion--initialized')) {

                const scope = this;
                DSV.DOM.window.off("resize", DSV.ui.accordionHandler.throttleCloseAllAccordions);
                this.DOM.module.removeClass('accordion--initialized');

                this.DOM.module.find(".accordion__body").each(function () {
                    const $this = $(this);
                    TweenLite.to($this, .3, {delay:.2, marginTop:0, onComplete:scope.removeAccordionEvents});
                });
            }
        },

        resizeHandler: DSV.tools.throttle(function() {
            let isAccordionView = DSV.tools.screenMode.currentMode < accordionBreakpoint;
            isAccordionView ? DSV.ui.accordionHandler.init(DSV.ui.siteSelector.DOM.module) : DSV.ui.siteSelector.undoAccordion();
        }, 100),

        init: function(){
            const that = this;
            let isAccordionView = DSV.tools.screenMode.currentMode < accordionBreakpoint;

            isAccordionView ? DSV.ui.accordionHandler.init(that.DOM.module) : null;

            DSV.DOM.window.on("resize", that.resizeHandler);
        }
    };

})(jQuery, window);